import firebase from 'firebase'
import router from '../../routes/router';
import { getUserConf, updateUserConf, updateWatchlists, getWatchlists, addHistory } from '../../dao/firestore';

export const MODE_PEA = 'pea';
export const MODE_CRYPTO = 'crypto';

const initialMode = document.URL.indexOf('pea') !== -1 ? MODE_PEA :
    document.URL.indexOf('crypto') !== -1 ? MODE_CRYPTO : MODE_PEA;

const state = {
    user: null,
    mode: initialMode, // pea, crypto, usa
    conf: {
        experience: -1,
        initialCapital: 0,
        termsAccepted: false,
        view: {
            theme: 'blue',
            darkmode: true
        },
        cash: 0,
        history: [],
        positions: [],
        search: [],
        minimumVolume: 50000,
        vals: [],
    },
    watchlists: [],
};

async function getProStatus() {
    await firebase.auth().currentUser.getIdToken(true);
    const decodedToken = await firebase.auth().currentUser.getIdTokenResult();
    return decodedToken.claims.stripeRole === 'premium';
}

export default {
    namespaced: true,
    state,
    getters: {
        user: state => state.user,
        mode: state => state.mode,
        conf: state => state.conf,
        watchlists: state => state.watchlists,
        getPosition: state => isin => state.conf.positions.find(p => p.isin === isin),
    },
    mutations: {
        SET_USER (state, payload) {
            state.user = payload;
        },
        LOGOUT (state, payload) {
            state.user = null
        },
        UPDATE_USER_CONF(state, payload) {
            state.conf = payload;
        },
        UPDATE_MODE(state, payload) {
            state.mode = payload;
        },
        UPDATE_WATCHLISTS(state, payload) {
            state.watchlists = payload;
        },
    },
    actions: {
        async autoSignIn({ commit, dispatch }, payload) {            
            const user = {
                ...payload.providerData[0], 
                uid: payload.uid, 
                creationTime: new Date(payload.metadata.creationTime)
            };
            commit('SET_USER', user)
            const userconf = await getUserConf(user, state.mode);
            if( userconf && userconf.experience ) {
                // get watchlists
                const watchlists = await getWatchlists(user, state.mode);
                commit('UPDATE_WATCHLISTS', watchlists);
                // Add pro mode
                commit('UPDATE_USER_CONF', {
                    ...userconf,
                    isPro: await getProStatus()
                })
                // Update background
                document.body.classList[userconf.view.darkmode?'remove':'add']('white-content');
            }
            else router.push('/onboarding');
            dispatch('instruments/getLive', state.mode, { root: true });
        },
        async changeMode({commit, state, dispatch}, payload) {
            commit('UPDATE_MODE', payload)
            const userconf = await getUserConf(state.user, payload);

            if (userconf && userconf.experience) {
                // get watchlists
                const watchlists = await getWatchlists(state.user, state.mode);
                commit('UPDATE_WATCHLISTS', watchlists);
                // Add pro mode
                commit('UPDATE_USER_CONF', {
                    ...userconf,
                    isPro: await getProStatus()
                })
                // Update background
                document.body.classList[userconf.view.darkmode?'remove':'add']('white-content');
            }
            else {
                router.push('/onboarding');
                commit('UPDATE_USER_CONF', {
                    experience: -1,
                    initialCapital: 0,
                    termsAccepted: false,
                    view: {
                        theme: 'blue',
                        darkmode: true
                    },
                    cash: 0,
                    history: [],
                    positions: [],
                    minimumVolume: 50000
                })
            }
            dispatch('instruments/getLive', payload, { root: true });
        },
        async signIn({ commit, dispatch }, payload) {
            var provider = null;
            if(payload == 'Twitter') provider = new firebase.auth.TwitterAuthProvider()
            else if(payload == 'Google') provider = new firebase.auth.GoogleAuthProvider()
            else if(payload == 'Apple') provider = new firebase.auth.OAuthProvider('apple.com')
            
            const result = await firebase.auth().signInWithPopup(provider);
            var user = result.user;
            const userconf = await getUserConf(user, state.mode);
            commit('SET_USER', user)
            
            if (userconf && userconf.experience) {
                // get watchlists
                const watchlists = await getWatchlists(user, state.mode);
                commit('UPDATE_WATCHLISTS', watchlists);
                // Add pro mode
                commit('UPDATE_USER_CONF', {
                    ...userconf,
                    isPro: await getProStatus()
                })
                // Update background
                document.body.classList[userconf.view.darkmode?'remove':'add']('white-content');
                router.push('/dashboard'); 
            }
            else router.push('/onboarding');
            dispatch('instruments/getLive', state.mode, { root: true });
        },
        logout({ commit }) {
            firebase.auth().signOut().then(function () {
                commit('LOGOUT')
                router.push('/login');
            }).catch(function (error) {
                alert(error)
                return
            });
        },
        async createconf({commit, state}, payload) {
            const newconf = {...state.conf, ...payload}
            await updateUserConf(state.user, newconf, state.mode)
            commit('UPDATE_USER_CONF', newconf)
            router.push('/dashboard');
        },
        async updateconf({commit, state}, payload) {
            const newconf = {...state.conf, ...payload}
            await updateUserConf(state.user, newconf, state.mode)
            commit('UPDATE_USER_CONF', newconf)
        },
        async addPositionHistory({ commit, state }, payload) {
            const positions = state.conf.positions;
            const index = positions.findIndex(p => p.isin === payload.isin);
            const history = positions[index].history || [];
            history.push(payload.transaction);
            positions[index].history = history.sort((a, b) => a.t - b.t);
            const newconf = {...state.conf, positions}
            await updateUserConf(state.user, newconf, state.mode)
            commit('UPDATE_USER_CONF', newconf)
        },
        async updatePosition({ commit, state }, payload) {
            const newHistory = {
                t: +new Date() / 1000,
                q: parseInt(payload.quantity),
                v: parseFloat(payload.value),
                s: -1
            };
            const positions = state.conf.positions;
            const index = positions.findIndex(p => p.isin === payload.isin);
            if (index != -1) {
                const history = positions[index].history || [];
                if (history.length === 0) {
                    // Aucune position enregistré, on ajoute l'actuelle
                    history.push({
                        t: +new Date() / 1000 - (1 * 24 * 60 * 60),
                        q: positions[index].quantity,
                        v: positions[index].value,
                        s: -1
                    })
                }
                history.push(newHistory);
                positions[index] = { ...payload, history };
            }
            else {
                positions.push(payload);
            }
            
            const newconf = {...state.conf, positions}
            await updateUserConf(state.user, newconf, state.mode)
            commit('UPDATE_USER_CONF', newconf)
        },
        async removePosition({ commit, state }, {isin, sellPrice}) {
            if (state.conf.isPro) {
                const index = state.conf.positions.findIndex(p => p.isin === isin);
                const historyWrapper = {
                    t: +new Date() / 1000,
                    history: state.conf.positions[index].history || [],
                    isin: isin,
                    author_id: state.user.uid,
                    mode: state.mode,
                };
                if (historyWrapper.history.length === 0) {
                    // Aucune position enregistré, on ajoute l'actuelle
                    historyWrapper.history.push({
                        t: +new Date() / 1000 - (1 * 24 * 60 * 60),
                        q: state.conf.positions[index].quantity,
                        v: state.conf.positions[index].value,
                        s: -1
                    })
                }
                historyWrapper.history.push({
                    t: +new Date() / 1000,
                    q: 0,
                    v: 0,
                    s: sellPrice
                });
                await addHistory(historyWrapper);
            }
            const positions = state.conf.positions.filter(p => p.isin != isin);
            const newconf = {...state.conf, positions}
            await updateUserConf(state.user, newconf, state.mode)
            commit('UPDATE_USER_CONF', newconf)
        },
        async addwatchlist({ commit, state }, payload) {
            const watchlists = state.watchlists;
            watchlists.push({
                name: payload,
                isin: [],
            });
            await updateWatchlists(state.user, watchlists, state.mode);
            commit('UPDATE_WATCHLISTS', watchlists);
        },
        async deleteWatchlist({ commit, state }, payload) {
            const watchlists = state.watchlists;
            watchlists.splice(payload, 1);
            await updateWatchlists(state.user, watchlists, state.mode);
            commit('UPDATE_WATCHLISTS', watchlists);
        },
        async addToWatchlist({ commit, state }, payload) {
            if (payload.watchlistIndex !== -1) {
                const watchlists = state.watchlists;
                watchlists[payload.watchlistIndex].isin.push(payload.isin);
                await updateWatchlists(state.user, watchlists, state.mode);
                commit('UPDATE_WATCHLISTS', watchlists);
            }
        },
        async removeFromWatchlist({ commit, state }, payload) {
            for (const watchlist of state.watchlists) {
                watchlist.isin.splice(watchlist.isin.indexOf(payload), 1);
            }
            await updateWatchlists(state.user, state.watchlists, state.mode);
            commit('UPDATE_WATCHLISTS', state.watchlists);
        },
        async addSearch({ commit, state }, payload) {
            let search = state.conf.search || [];
            search = search.filter(s => s !== payload);
            search.unshift(payload);
            search = search.slice(0, 5);
            const newconf = {...state.conf, search}
            await updateUserConf(state.user, newconf, state.mode)
            commit('UPDATE_USER_CONF', newconf)
        },
        async addCustomValue({ commit, state }, payload) {
            let vals = state.conf.vals || [];
            vals.push(payload);
            const newconf = {...state.conf, vals}
            await updateUserConf(state.user, newconf, state.mode)
            commit('UPDATE_USER_CONF', newconf)
        },
        async editCustomValue({ commit, state }, payload) {
            const vals = state.conf.vals || [];
            const index = vals.findIndex(v => v.isin === payload.isin);
            vals[index].v = payload.v;
            const newconf = {...state.conf, vals}
            await updateUserConf(state.user, newconf, state.mode)
            commit('UPDATE_USER_CONF', newconf)
        },
        async deleteCustomValue({ commit, state }, payload) {
            let vals = (state.conf.vals || []).filter(v => v.isin !== payload);
            const newconf = {...state.conf, vals}
            await updateUserConf(state.user, newconf, state.mode)
            commit('UPDATE_USER_CONF', newconf)
        },
    }
};